/* eslint-disable import/no-unresolved */
import { Grid, Box, Button, Typography, Stack } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import isElectron from 'is-electron';
import {
  selectCart,
  selectOrder,
  selectPrinter,
  selectAuth,
} from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';
import { closeModal } from '@/store/slices/modal';
import { ScrollBar } from '@/styles/global';
import { printInvoice } from '@/utils/printer';
import { useFetchCompany } from '@/services/hooks/useFetchCompany';

const InvoiceDetails = () => {
  const { items } = useSelector(selectCart);
  const {
    taxes,
    discount,
    customer,
    current_invoice: invoice,
    change,
    prev_change,
    paymentMethod,
    sub_total: subTotal,
    total,
    changeGiven,
    changeSaved,
  } = useSelector(selectOrder);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: profile } = useFetchPosProfileDetails();
  const { data: company } = useFetchCompany();
  const { fullName } = useSelector(selectAuth);
  const companyDetails = company?.message[0].data;

  const { default: defaultPrinter } = useSelector(selectPrinter);
  console.log(profile);
  const restaurant = profile?.restaurant;
  const currency = profile?.currency;

  const handleModalClose = () => {
    dispatch(closeModal({ type: 'printInvoice' }));
    navigate('/tables');
  };

  const handlePrintInvoice = () => {
    dispatch(closeModal({ type: 'printInvoice' }));

    const printerObj = {
      showBusinessInfo: profile?.custom_show_business_details_on_receipt,
      businessInfo: companyDetails || {},
      taxId: profile?.tax_id,
      ipAddress: defaultPrinter.ipAddress,
      port: defaultPrinter.port,
      invoice,
      items,
      customer,
      cashier: fullName,
      restaurant,
      taxes,
      netTotal: total.toString(),
      subTotal: subTotal.toString(),
      currency,
      message: profile?.print_footer,
      change,
      changeGiven,
      changeSaved,
      paymentMethod: profile?.custom_enable_payment_method_on_invoice
        ? paymentMethod
        : [],
      discount: discount.toString(),
    };

    if (isElectron()) {
      printInvoice(printerObj);
    } else {
      navigate('/generate-invoice', { state: { ...printerObj } });
    }
  };

  const deliveryFee: any = localStorage.getItem('order_c');

  const totalAmount = total + (parseFloat(deliveryFee as string) || 0);

  return (
    <Box mt={0}>
      <Grid container columnSpacing={4} rowSpacing={4}>
        {/* ITEMS LIST */}
        <Grid item xs={12}>
          <Box
            sx={{
              border: '1px solid #D9D9D9',
              borderRadius: '20px',
              backgroundColor: '#fff',
              width: '100%',
              maxHeight: '200px',
              height: '150px',
              overflow: 'auto',
              padding: '32px 45px',
              ...ScrollBar,
            }}
          >
            {items.map((item) => (
              <Stack
                direction="row"
                key={item.item_code}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mx: 'auto',
                  mb: 1,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: '600',
                    fontFamily: 'Montserrat',
                    textTransform: 'capitalize',
                    flex: 1,
                    textAlign: 'left',
                  }}
                >
                  {item.item_name}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: 'Montserrat',
                    flex: 1,
                  }}
                >
                  {item.qty}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: 'Montserrat',
                    flex: 1,
                  }}
                >
                  {profile?.currency}
                  {item.price_list_rate.toLocaleString('en-US')}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: 'Montserrat',
                    flex: 1,
                  }}
                >
                  {profile?.currency}
                  {(item.qty * item.price_list_rate).toLocaleString('en-US')}
                </Typography>
              </Stack>
            ))}
          </Box>
        </Grid>

        {/* ITEMS TOTAL */}
        <Grid item xs={12}>
          <Box
            sx={{
              border: '1px solid #D9D9D9',
              borderRadius: '20px',
              backgroundColor: '#fff',
              width: '100%',
              maxHeight: '200px',
              height: '200px',
              overflow: 'auto',
              padding: '32px 45px',
            }}
          >
            <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mx: 'auto',
                mb: 1,
              }}
            >
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontWeight: '600',
                  fontFamily: 'Montserrat',
                }}
              >
                Subtotal
              </Typography>
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontWeight: '600',
                  fontFamily: 'Montserrat',
                }}
              >
                {profile?.currency}
                {subTotal.toLocaleString('en-US')}
              </Typography>
            </Stack>
            {taxes.map((tax) => (
              <Stack
                key={tax.account_head}
                direction="row"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mx: 'auto',
                  mb: 1,
                }}
              >
                <Typography fontFamily="Montserrat">
                  {tax.description}
                </Typography>
                <Typography fontFamily="Montserrat">
                  {profile?.currency}
                  {tax.tax_amount.toLocaleString('en-US')}
                </Typography>
              </Stack>
            ))}

            {/* <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mx: 'auto',
                mb: 1,
              }}
            >
              <Typography fontFamily="Montserrat">VAT</Typography>
              <Typography fontFamily="Montserrat">
                {profile?.currency}
                {tax.toLocaleString('en-US')}
              </Typography>
            </Stack> */}
            <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mx: 'auto',
                mb: 1,
              }}
            >
              <Typography fontFamily="Montserrat">Discount</Typography>
              <Typography fontFamily="Montserrat">
                {profile?.currency}
                {discount.toLocaleString('en-US')}
              </Typography>
            </Stack>
            {!isNaN(deliveryFee) && typeof deliveryFee !== 'number' && (
              <Stack
                direction="row"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mx: 'auto',
                  mb: 1,
                }}
              >
                <Typography fontFamily="Montserrat">Delivery Fee</Typography>
                <Typography fontFamily="Montserrat">
                  {profile?.currency}
                  {deliveryFee || 0}
                </Typography>
              </Stack>
            )}
            <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mx: 'auto',
                mb: 1,
              }}
            >
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontWeight: '600',
                  fontFamily: 'Montserrat',
                }}
              >
                Total
              </Typography>
              <Typography
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  fontWeight: '600',
                  fontFamily: 'Montserrat',
                }}
              >
                {profile?.currency}
                {totalAmount.toLocaleString('en-US')}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mx: 'auto',
                mb: 1,
              }}
            >
              <Typography fontFamily="Montserrat">Change</Typography>
              <Typography fontFamily="Montserrat">
                {profile?.currency}
                {prev_change?.toLocaleString('en-US')}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mx: 'auto',
                mb: 1,
              }}
            >
              <Typography fontFamily="Montserrat">Change given</Typography>
              <Typography fontFamily="Montserrat">
                {profile?.currency}
                {changeGiven?.toLocaleString('en-US')}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mx: 'auto',
                mb: 1,
              }}
            >
              <Typography fontFamily="Montserrat">Change saved</Typography>
              <Typography fontFamily="Montserrat">
                {profile?.currency}
                {changeSaved?.toLocaleString('en-US')}
              </Typography>
            </Stack>
          </Box>
        </Grid>

        {/* PRINT INVOICE BUTTON */}
        <Grid item xs={6} sx={{ mx: 'auto' }}>
          <Button
            type="submit"
            variant="contained"
            sx={{ borderRadius: 2 }}
            onClick={handlePrintInvoice}
          >
            Print Invoice
          </Button>

          <Button
            type="submit"
            variant="contained"
            sx={{ borderRadius: 2, mt: 3 }}
            onClick={handleModalClose}
          >
            Done
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InvoiceDetails;
